import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
  Button,
  Container,
  Row,
  Col,
  FormGroup,
  InputGroupAddon,
  InputGroup,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import { TezosToolkit } from '@taquito/taquito';
import TransportWebHID from '@ledgerhq/hw-transport-webhid';
import { LedgerSigner, DerivationType } from '@taquito/ledger-signer';

import {
  dictAliases,
  listAdresses,
  rpcNode,
  callEntrypoint,
  salvusParameters,
  registerOperation,
} from '../../helpers/api';
import { truncStringPortion } from '../../helpers/formatter.js';
import LoadingTx from './Modals/LoadingTx.js';
import SuccessTx from './Modals/SuccessTx.js';
import SVGLogo from '../../components/Common/SVGLogo.js';
import TezosLogo from '../../components/Common/TezosLogo.js';
import Breadcrumbs from '../../components/Common/Breadcrumb';

const derivationPath = "44'/1729'/0'/0'/0'";

class TransferEURUS extends Component {
  constructor(props) {
    super(props);
    this.state = {
      decimals: 100,
      tokenId: 0,
      multiSigs: [],
      wallets: [],
      loading: true,
      selectedWallet: {},
      keystore: null,
      connected: false,
      pending: false,
      success: null,
      error: null,
      tezosNode: null,
      parameters: null,
      contract: null,
      receiver: null,
      currentStep: 1,
      walletName: null,
      receiverName: null,
      eurusAmount: 0,
      dropdownOpen: false,
      dropdownRcv: false,
      aliases: [],
    };
    this.passPhrase = React.createRef();
    this.amount = React.createRef();
    this.cents = React.createRef();
  }

  componentDidMount = () => {
    this._asyncRequest = listAdresses()
      .then((res) => {
        if (res.status === 'SUCCESS') {
          let resWallets = res.data.wallets;
          resWallets.sort(function (a, b) {
            var x = parseFloat(a.value.balance);
            var y = parseFloat(b.value.balance);
            if (x > y) {
              return -1;
            }
            if (x < y) {
              return 1;
            }
            return 0;
          });
          this.setState({
            wallets: resWallets,
            multiSigs: res.data.multiSigs,
            loading: false,
          });
          this._asyncRequest = rpcNode()
            .then((result) => {
              this.setState({ tezosNode: result.data });
            })
            .catch((error) => {
              console.log(error);
            });
          this._asyncRequest = salvusParameters()
            .then((result) => {
              this.setState({
                parameters: result.data.parameters,
                contract: result.data.contract,
              });
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          console.log(res.error);
        }
      })
      .catch((error) => {
        console.log(error);
      });
    this._asyncRequest = dictAliases()
      .then((res) => {
        if (res.status === 'SUCCESS') {
          this.setState({
            aliases: res.data,
            decimals: res.decimals,
            tokenId: res.tokenId,
          });
        } else {
          console.log(res.error);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  toggleDropdown = () => {
    this.setState({ dropdownOpen: !this.state.dropdownOpen });
  };

  toggleDropdownRcv = () => {
    this.setState({ dropdownRcv: !this.state.dropdownRcv });
  };

  changePassActive = (wallet) => {
    this.setState({
      passActive: wallet.walletType,
      selectedWallet: wallet.publicKeyHash,
      walletName: wallet.name,
    });
    this.setState({ currentStep: 2 });
  };

  selectReceiver = (wallet) => {
    this.setState({
      receiver: wallet.publicKeyHash,
      receiverName: wallet.name,
      currentStep: 4,
    });
  };

  ledgerSendOp = async () => {
    try {
      this.setState({
        pending: true,
        info: `Connect your Ledger and approve connection request`,
      });
      const Tezos = new TezosToolkit(this.state.tezosNode);
      const transport = await TransportWebHID.create();
      const ledgerSigner = new LedgerSigner(
        transport, //required
        derivationPath, // path optional (equivalent to "44'/1729'/1'/0'")
        true, // prompt optional
        DerivationType.ED25519, // derivationType optional
      );
      Tezos.setProvider({ signer: ledgerSigner });
      const publicKeyHash = await Tezos.signer.publicKeyHash();
      if (this.state.selectedWallet !== publicKeyHash) {
        this.setState({
          error: 'Not connected with the right Ledger',
          pending: false,
          success: false,
        });
        return;
      }
      const contract = await Tezos.wallet.at(this.state.contract);
      let operation = {};
      this.setState({
        info: `Follow the instruction from your Ledger to send operation`,
      });
      if (this.state.tokenId || this.state.tokenId === 0) {
        operation = await contract.methods
          .transfer([
            {
              from_: this.state.selectedWallet,
              txs: [
                {
                  to_: this.state.receiver,
                  token_id: this.state.tokenId,
                  amount: Math.round(
                    parseFloat(this.state.eurusAmount) * this.state.decimals,
                  ),
                },
              ],
            },
          ])
          .send();
      } else {
        operation = await contract.methods
          .transfer(
            Math.round(
              parseFloat(this.state.eurusAmount) * this.state.decimals,
            ),
            this.state.selectedWallet,
            this.state.receiver,
          )
          .send();
      }
      this.setState({
        info: 'Awaiting confirmation. It may take up to 1 min...',
      });
      await operation.confirmation();
      this.setState({
        pending: false,
        success: `Operation ${operation.opHash} sent`,
      });
      this._asyncRequest = registerOperation(
        operation.opHash,
        '€ Transfer',
        `Transfer ${this.state.eurusAmount}€ to ${truncStringPortion(
          this.state.receiver,
          8,
          6,
        )}`,
        this.state.selectedWallet,
        'token',
      )
        .then((response) => {
          console.log(response.status);
        })
        .catch((error) => {
          console.log(error);
        });
      await transport.close();
    } catch (e) {
      console.log(e);
      this.setState({
        pending: false,
        info: null,
        success: false,
        error: JSON.stringify(e),
      });
    }
  };

  platformSendOp = () => {
    let genParams = {};
    if (this.state.tokenId || this.state.tokenId === 0) {
      genParams = {
        entrypoint: 'transfer',
        parameters: `{Pair "${this.state.selectedWallet}" {Pair "${
          this.state.receiver
        }" (Pair ${this.state.tokenId} ${Math.round(
          parseFloat(this.state.eurusAmount) * this.state.decimals,
        )})}}`,
      };
    } else {
      genParams = {
        entrypoint: 'transfer',
        parameters: `(Pair ${Math.round(
          parseFloat(this.state.eurusAmount) * this.state.decimals,
        )} (Pair "${this.state.selectedWallet}" "${this.state.receiver}"))`,
      };
    }
    this.setState({ pending: true, error: null, success: null });
    this._asyncRequest = callEntrypoint(
      genParams,
      this.state.selectedWallet,
      this.passPhrase.current.value,
      'token',
    )
      .then((res) => {
        if (res.status === 'SUCCESS') {
          this.setState({
            pending: false,
            success: `Operation ${res.data} sent`,
          });
          this._asyncRequest = registerOperation(
            res.data,
            '€ Transfer',
            `Transfer ${this.state.eurusAmount}€ to ${truncStringPortion(
              this.state.receiver,
              8,
              6,
            )}`,
            this.state.selectedWallet,
            'token',
          )
            .then((response) => {
              console.log(response.status);
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          this.setState({ pending: false, error: res.error });
        }
      })
      .catch((error) => {
        this.setState({ pending: false, error: error.toString() });
      });
  };

  handleChangeInput = (event) => {
    this.cents.current.value = event.target.value.slice(0, 2);
  };

  setAmount = () => {
    this.setState({ currentStep: 3 });
    if (this.cents.current.value) {
      this.setState({
        eurusAmount: this.amount.current.value + '.' + this.cents.current.value,
      });
    } else {
      this.setState({ eurusAmount: this.amount.current.value });
    }
  };

  changeStep = (step) => {
    this.setState({ currentStep: step, success: null, error: null });
  };

  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid className="mHeight">
            <LoadingTx
              pending={this.state.pending}
              info={this.state.info}
              passActive={this.state.passActive}
            />
            <SuccessTx
              success={this.state.success}
              passActive={this.state.passActive}
              amount={this.state.eurusAmount}
              currency={'EUR-L'}
              sender={this.state.selectedWallet}
              receiver={this.state.receiver}
              aliases={this.state.aliases}
            />
            {/* Render Breadcrumbs */}
            <Breadcrumbs title="Wallets" breadcrumbItem="Transfer EUROP" />
            {this.state.loading ? (
              <div className="text-center my-3">
                <Link to="#" className="text-primary">
                  <i className="bx bx-loader bx-spin font-size-18 align-middle mr-2"></i>{' '}
                  Loading wallets...{' '}
                </Link>
              </div>
            ) : (
              <>
                {this.state.error && (
                  <p className="badge badge-danger font-size-12">
                    {this.state.error}
                  </p>
                )}
                {this.state.success && (
                  <p className="badge badge-success font-size-12">
                    {this.state.success}
                  </p>
                )}
                <p>
                  <small>
                    {this.state.tokenId || this.state.tokenId === 0
                      ? 'FA2 Contract'
                      : 'FA1.2 Contract'}
                  </small>
                </p>
                {this.state.currentStep !== 1 ? (
                  <div
                    className="media mb-2 mt-2"
                    onClick={() => {
                      this.changeStep(1);
                    }}
                  >
                    <div className="avatar-xs mr-3">
                      <span className="avatar-title bg-success rounded-circle font-size-16">
                        1
                      </span>
                    </div>
                    <div className="media-body">
                      <p className="mb-0">
                        Sender <b>{this.state.walletName}</b> (
                        {truncStringPortion(this.state.selectedWallet, 8, 6)})
                        selected
                      </p>
                      <span className="text-muted font-size-10 mt-0">
                        Click to change sender
                      </span>
                      <Row>
                        {this.state.wallets &&
                          this.state.wallets.map(
                            (wallet) =>
                              this.state.selectedWallet ===
                                wallet.publicKeyHash && (
                                <Col
                                  xl="4"
                                  sm="12"
                                  key={`sel-${wallet.publicKeyHash}`}
                                >
                                  <div className="mb-3">
                                    <label className="card-radio-label mb-2">
                                      <div className="card-radio p-2">
                                        <div>
                                          {wallet.walletType === 'ledger' ? (
                                            <i className="mdi mdi-shield-key font-size-24 text-info align-middle mr-2"></i>
                                          ) : (
                                            <i className="mdi mdi-wallet font-size-24 text-warning align-middle mr-2"></i>
                                          )}
                                          <span
                                            dangerouslySetInnerHTML={{
                                              __html: wallet.name.replace(
                                                '(',
                                                '<br/>(',
                                              ),
                                            }}
                                          ></span>
                                          <p className="text-muted font-size-11 mb-1">
                                            {wallet.publicKeyHash}
                                          </p>
                                          <p className="font-size-16 mb-1">
                                            <SVGLogo />{' '}
                                            {parseFloat(
                                              wallet.value.balance /
                                                this.state.decimals,
                                            ).toLocaleString('fr')}
                                          </p>
                                        </div>
                                      </div>
                                    </label>
                                  </div>
                                </Col>
                              ),
                          )}
                      </Row>
                    </div>
                  </div>
                ) : (
                  <div className="media mb-2 mt-2">
                    <div className="avatar-xs mr-3">
                      <span className="avatar-title bg-primary rounded-circle font-size-16">
                        1
                      </span>
                    </div>
                    <div className="media-body">
                      <p className="mt-1">
                        <b>Select sender</b>
                      </p>
                    </div>
                  </div>
                )}
                {this.state.currentStep === 1 && (
                  <Row className="mb-3">
                    <Col md="12">
                      {this.state.wallets.length > 0 && (
                        <Dropdown
                          isOpen={this.state.dropdownOpen}
                          toggle={this.toggleDropdown}
                        >
                          <DropdownToggle caret color="primary">
                            Select a sending wallet
                          </DropdownToggle>
                          <p className="text-muted font-size-10 mt-1">
                            You do not see the sending wallet you want? Make
                            sure it is revealed with a positive EUR-L balance
                          </p>
                          <DropdownMenu>
                            {this.state.wallets &&
                              this.state.wallets.map(
                                (wallet) =>
                                  wallet.walletType !== 'client' &&
                                  wallet.value.balance > 0 &&
                                  wallet.details.is_revealed && (
                                    <DropdownItem
                                      onClick={() => {
                                        this.changePassActive(wallet);
                                      }}
                                      key={wallet.publicKeyHash}
                                    >
                                      {wallet.walletType === 'ledger' ? (
                                        <i className="mdi mdi-shield-key font-size-24 text-info align-middle mr-2"></i>
                                      ) : (
                                        <i className="mdi mdi-wallet font-size-24 text-warning align-middle mr-2"></i>
                                      )}
                                      <span>{wallet.name}</span> |{' '}
                                      <span className="text-muted font-size-10 mr-1">
                                        {truncStringPortion(
                                          wallet.publicKeyHash,
                                          8,
                                          6,
                                        )}
                                      </span>
                                      |
                                      <span className="ml-1 mr-1">
                                        {wallet.details.total_balance
                                          ? Math.round(
                                              wallet.details.total_balance *
                                                100,
                                            ) / 100
                                          : 0}{' '}
                                        <TezosLogo width="14" height="14" /> |
                                        <span className="text-muted font-size-10 ml-1">
                                          ~
                                          {wallet.details.total_balance > 0.05
                                            ? Math.round(
                                                wallet.details.total_balance /
                                                  0.05,
                                              )
                                            : 0}{' '}
                                          operations
                                        </span>
                                      </span>
                                      |
                                      <span>
                                        <SVGLogo />{' '}
                                        {parseFloat(
                                          wallet.value.balance /
                                            this.state.decimals,
                                        ).toLocaleString('fr')}
                                      </span>
                                    </DropdownItem>
                                  ),
                              )}
                          </DropdownMenu>
                        </Dropdown>
                      )}
                    </Col>
                  </Row>
                )}
              </>
            )}
            {this.state.currentStep > 2 ? (
              <div
                className="media mb-2 mt-2"
                onClick={() => {
                  this.changeStep(2);
                }}
              >
                <div className="avatar-xs mr-3">
                  <span className="avatar-title bg-success rounded-circle font-size-16">
                    2
                  </span>
                </div>
                <div className="media-body">
                  <p className="mb-0">
                    Set transfer for{' '}
                    <b>
                      {this.state.eurusAmount} <SVGLogo />{' '}
                    </b>
                  </p>
                  <span className="text-muted font-size-10 mt-0">
                    Click to change amount
                  </span>
                </div>
              </div>
            ) : (
              <div className="media mb-2 mt-2">
                <div className="avatar-xs mr-3">
                  <span className="avatar-title bg-primary rounded-circle font-size-16">
                    2
                  </span>
                </div>
                <div className="media-body">
                  <p className="mt-1">
                    <b>
                      Set <SVGLogo /> amount
                    </b>
                  </p>
                </div>
              </div>
            )}
            {this.state.currentStep === 2 && (
              <Row>
                <Col sm="8">
                  <InputGroup className="mb-2">
                    <InputGroupAddon addonType="prepend">
                      <span className="input-group-text">
                        Amount in <SVGLogo />{' '}
                      </span>
                    </InputGroupAddon>
                    <input
                      type="number"
                      ref={this.amount}
                      placeholder="Amount in €"
                      min="1"
                      className="form-control text-right w-50 mr-0"
                    />
                    <InputGroupAddon addonType="prepend">
                      <span className="input-group-text">.</span>
                    </InputGroupAddon>
                    <input
                      type="number"
                      ref={this.cents}
                      placeholder="00"
                      min="0"
                      max="99"
                      maxLength="2"
                      className="form-control ml-0"
                      onChange={this.handleChangeInput}
                    />
                  </InputGroup>
                </Col>
                <Col sm="4">
                  <Button
                    type="button"
                    color="success"
                    onClick={() => {
                      this.setAmount();
                    }}
                  >
                    Set amount
                  </Button>
                </Col>
              </Row>
            )}
            {this.state.currentStep > 3 ? (
              <div
                className="media mb-2 mt-2"
                onClick={() => {
                  this.changeStep(3);
                }}
              >
                <div className="avatar-xs mr-3">
                  <span className="avatar-title bg-success rounded-circle font-size-16">
                    3
                  </span>
                </div>
                <div className="media-body">
                  <p className="mb-0">
                    Receiver <b>{this.state.receiverName}</b> (
                    {truncStringPortion(this.state.receiver, 8, 6)}) selected
                  </p>
                  <span className="text-muted font-size-10 mt-0">
                    Click to change receiver
                  </span>
                  <Row>
                    {this.state.wallets &&
                      this.state.wallets.map(
                        (wallet) =>
                          this.state.receiver === wallet.publicKeyHash && (
                            <Col
                              xl="4"
                              sm="12"
                              key={`rcv-${wallet.publicKeyHash}`}
                            >
                              <div className="mb-3">
                                <label className="card-radio-label mb-2">
                                  <div className="card-radio p-2">
                                    <div>
                                      {wallet.walletType === 'ledger' ? (
                                        <i className="mdi mdi-shield-key font-size-24 text-info align-middle mr-2"></i>
                                      ) : (
                                        <i className="mdi mdi-wallet font-size-24 text-warning align-middle mr-2"></i>
                                      )}
                                      <span
                                        dangerouslySetInnerHTML={{
                                          __html: wallet.name.replace(
                                            '(',
                                            '<br/>(',
                                          ),
                                        }}
                                      ></span>
                                      <p className="text-muted font-size-11 mb-1">
                                        {wallet.publicKeyHash}
                                      </p>
                                      <p className="font-size-16 mb-1">
                                        <SVGLogo />{' '}
                                        {parseFloat(
                                          wallet.value.balance /
                                            this.state.decimals,
                                        ).toLocaleString('fr')}
                                      </p>
                                    </div>
                                  </div>
                                </label>
                              </div>
                            </Col>
                          ),
                      )}
                    {this.state.multiSigs &&
                      this.state.multiSigs.map(
                        (multiSig) =>
                          this.state.receiver === multiSig.publicKeyHash && (
                            <Col
                              xl="4"
                              sm="12"
                              key={`rcv-${multiSig.publicKeyHash}`}
                            >
                              <div className="mb-3">
                                <label className="card-radio-label mb-2">
                                  <div className="card-radio p-2">
                                    <div>
                                      <i className="mdi mdi-draw font-size-24 text-warning align-middle mr-2"></i>
                                      <span
                                        dangerouslySetInnerHTML={{
                                          __html: multiSig.name.replace(
                                            '(',
                                            '<br/>(',
                                          ),
                                        }}
                                      ></span>
                                      <p className="text-muted font-size-11 mb-1">
                                        {multiSig.publicKeyHash}
                                      </p>
                                      <p className="font-size-16 mb-1">
                                        <SVGLogo />{' '}
                                        {parseFloat(
                                          multiSig.value.balance /
                                            this.state.decimals,
                                        ).toLocaleString('fr')}
                                      </p>
                                    </div>
                                  </div>
                                </label>
                              </div>
                            </Col>
                          ),
                      )}
                  </Row>
                </div>
              </div>
            ) : (
              <div className="media mb-2 mt-2">
                <div className="avatar-xs mr-3">
                  <span className="avatar-title bg-primary rounded-circle font-size-16">
                    3
                  </span>
                </div>
                <div className="media-body">
                  <p className="mt-1">
                    <b>Selected receiver</b>
                  </p>
                </div>
              </div>
            )}
            {this.state.currentStep === 3 && (
              <Row className="mb-3">
                <Col md="12">
                  {this.state.wallets.length > 0 && (
                    <Dropdown
                      isOpen={this.state.dropdownRcv}
                      toggle={this.toggleDropdownRcv}
                    >
                      <DropdownToggle caret color="primary">
                        Select a receiving wallet
                      </DropdownToggle>
                      <DropdownMenu>
                        {this.state.multiSigs &&
                          this.state.multiSigs.map(
                            (multiSig) =>
                              multiSig.name === 'Reserve' && (
                                <DropdownItem
                                  key={'rcv_' + multiSig.publicKeyHash}
                                  onClick={() => {
                                    this.selectReceiver(multiSig);
                                  }}
                                >
                                  <i className="mdi mdi-draw font-size-24 text-warning align-middle mr-2"></i>
                                  <span>{multiSig.name}</span> |{' '}
                                  <span className="text-muted font-size-10 mr-1">
                                    {truncStringPortion(
                                      multiSig.publicKeyHash,
                                      8,
                                      6,
                                    )}
                                  </span>
                                  |
                                  <span className="ml-1 mr-1">
                                    <SVGLogo />{' '}
                                    {parseFloat(
                                      multiSig.value.balance /
                                        this.state.decimals,
                                    ).toLocaleString('fr')}
                                  </span>
                                </DropdownItem>
                              ),
                          )}
                        {this.state.wallets &&
                          this.state.wallets.map((wallet) => (
                            <DropdownItem
                              key={'rcv_' + wallet.publicKeyHash}
                              onClick={() => {
                                this.selectReceiver(wallet);
                              }}
                            >
                              {wallet.walletType === 'ledger' ? (
                                <i className="mdi mdi-shield-key font-size-24 text-info align-middle mr-2"></i>
                              ) : wallet.walletType === 'platform' ? (
                                <i className="mdi mdi-wallet font-size-24 text-warning align-middle mr-2"></i>
                              ) : (
                                <i className="mdi mdi-account-circle-outline font-size-24 text-primary align-middle mr-2"></i>
                              )}
                              <span>{wallet.name}</span> |{' '}
                              <span className="text-muted font-size-10 mr-1">
                                {truncStringPortion(wallet.publicKeyHash, 8, 6)}
                              </span>
                              |
                              <span className="ml-1 mr-1">
                                <SVGLogo />{' '}
                                {parseFloat(
                                  wallet.value.balance / this.state.decimals,
                                ).toLocaleString('fr')}
                              </span>
                            </DropdownItem>
                          ))}
                      </DropdownMenu>
                    </Dropdown>
                  )}
                </Col>
              </Row>
            )}
            <div className="media mb-2 mt-2">
              {this.state.success ? (
                <div
                  className="media mb-2 mt-2"
                  onClick={() => {
                    this.changeStep(3);
                  }}
                >
                  <div className="avatar-xs mr-3">
                    <span className="avatar-title bg-success rounded-circle font-size-16">
                      4
                    </span>
                  </div>
                  <div className="media-body">
                    <p className="mt-1">
                      Operation <b>sent successfully</b>
                    </p>
                  </div>
                </div>
              ) : this.state.error ? (
                <div className="media mb-2 mt-2">
                  <div className="avatar-xs mr-3">
                    <span className="avatar-title bg-danger rounded-circle font-size-16">
                      4
                    </span>
                  </div>
                  <div className="media-body">
                    <p className="mt-1">
                      <b>EUROP could not be sent</b>
                    </p>
                  </div>
                </div>
              ) : (
                <div className="media mb-2 mt-2">
                  <div className="avatar-xs mr-3">
                    <span className="avatar-title bg-primary rounded-circle font-size-16">
                      4
                    </span>
                  </div>
                  <div className="media-body">
                    <p className="mt-1">
                      <b>Send operation</b>
                    </p>
                  </div>
                </div>
              )}
            </div>
            {this.state.currentStep === 4 && (
              <>
                {this.state.passActive === 'platform' &&
                  !this.state.success && (
                    <FormGroup className="mt-4">
                      <InputGroup className="mb-2">
                        <InputGroupAddon addonType="prepend">
                          <span className="input-group-text">Passphrase</span>
                        </InputGroupAddon>
                        <input
                          type="password"
                          ref={this.passPhrase}
                          className="form-control"
                        />
                      </InputGroup>
                    </FormGroup>
                  )}
                {this.state.passActive === 'platform' && (
                  <>
                    {this.state.pending ? (
                      <p>Processing operation, please wait...</p>
                    ) : (
                      !this.state.success && (
                        <div className="text-center mt-4 mb-2">
                          <Button
                            type="button"
                            color="success"
                            onClick={() => {
                              this.platformSendOp();
                            }}
                          >
                            Send <SVGLogo />
                          </Button>
                        </div>
                      )
                    )}
                  </>
                )}
                {this.state.passActive === 'ledger' && (
                  <>
                    {this.state.pending ? (
                      <p>Follow further instructions on your ledger...</p>
                    ) : (
                      !this.state.success && (
                        <div className="text-center mt-4 mb-2">
                          <Button
                            type="button"
                            color="success"
                            onClick={() => {
                              this.ledgerSendOp();
                            }}
                          >
                            Send <SVGLogo />
                          </Button>
                        </div>
                      )
                    )}
                  </>
                )}
              </>
            )}
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default TransferEURUS;
